import { render, staticRenderFns } from "./debug-panel.vue?vue&type=template&id=a3cdf864&scoped=true"
import script from "./debug-panel.vue?vue&type=script&lang=js"
export * from "./debug-panel.vue?vue&type=script&lang=js"
import style0 from "./debug-panel.vue?vue&type=style&index=0&id=a3cdf864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cdf864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
